import { useSyncExternalStore } from 'react';

/** Tailwind breakpoints used by the shell (DESIGN.md §9.1 responsive table). */
export const BREAKPOINTS = {
  md: '(min-width: 48rem)',
  xl: '(min-width: 80rem)',
} as const;

/** Subscribes to a CSS media query. Returns `false` where matchMedia is unavailable (tests, SSR). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = globalThis.matchMedia?.(query);
      list?.addEventListener('change', onChange);
      return () => list?.removeEventListener('change', onChange);
    },
    () => globalThis.matchMedia?.(query).matches ?? false,
    () => false,
  );
}
